import React, {memo} from 'react'
import _ from 'lodash'
import {Button, Form, Grid, Header, List, Message, Segment} from 'semantic-ui-react'
import {qs} from '../../util'
import {withErrorHandling, withHelmet, withQueryParams, withMeData, withPropsPresent} from '../../hoc'
import {useSafeState} from '../../hook'
import {login} from '../../backend'

const _Login = (
  {
    query,
    navigate,
    login,
    mutateMe,
    setError
  }
) => {
  const [state, setState] = useSafeState({
    email: query.email || '',
    password: '',
    submitted: false,
    errors: {}
  })

  const validate = ({email, password, errors = {}}) => {
    if (!email) {
      errors['login.email.required'] = 'Email required'
    } else {
      delete errors['login.email.required']
      if (email.length > 255) {
        errors['login.email.exceeds.max.length'] = 'Email cannot exceed 255 characters'
      } else {
        delete errors['login.email.exceeds.max.length']
      }
    }
    if (!password) {
      errors['login.password.required'] = 'Password required'
    } else {
      delete errors['login.password.required']
      if (password.length > 255) {
        errors['login.password.exceeds.max.length'] = 'Password cannot exceed 255 characters'
      } else {
        delete errors['login.password.exceeds.max.length']
      }
    }
    return errors
  }

  const onInputChange = (e) => {
    let updatedState = {...state, ...{[e.target.name]: e.target.value}}
    let errors = {}
    if (state.submitted) {
      errors = validate(updatedState)
      updatedState = {...updatedState, ...{errors}}
    }
    setState(updatedState)
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    const errors = validate(state)
    delete errors['login.invalid.credentials']
    if (_.keys(errors).length) {
      setState({...state, ...{errors}})
      return
    }
    const updatedState = {...state, ...{submitting: true}}
    setState(updatedState)
    try {
      await login(updatedState)
      await mutateMe()
      navigate('/c/services')
    } catch (e) {
      if (e.status === 401) {
        const {errors} = updatedState
        errors['login.invalid.credentials'] = 'Invalid credentials. Try again.'
        setState({...updatedState, ...{errors, submitting: false}})
        return
      }
      setState({...updatedState, ...{submitting: false}})
      setError(e)
    }
  }

  const {email, password, errors, submitting} = state
  const hasEmailError = _.keys(errors).some((k) => k.indexOf('login.email') > -1 || k.indexOf('login.invalid') > -1)
  const hasPasswordError = _.keys(errors).some((k) => k.indexOf('login.password') > -1 || k.indexOf('login.invalid') > -1)
  const hasErrors = hasEmailError || hasPasswordError

  const queryString = qs(query)

  return (
    <Grid centered doubling columns={2}>
      <Grid.Column width={6}>
        <Header as='h1'>Log In</Header>
        <Segment>
          {
            query.confirmed === 'true' && (<Message success>Account confirmed! Please sign in.</Message>)
          }
          {
            !!query.invitation && (
              <Message success>Invitation to account: {query.invitation} successfully accepted. Please sign
                in.</Message>)
          }
          <Form error={hasErrors} onSubmit={onSubmit}>
            <Form.Field error={hasEmailError} required>
              <label>Email</label>
              <Form.Input placeholder='Enter email'
                          name='email'
                          value={email}
                          autoComplete='false'
                          onChange={onInputChange}/>
            </Form.Field>
            <Form.Field error={hasPasswordError} required>
              <label>Password</label>
              <Form.Input placeholder='Enter password'
                          name='password'
                          value={password}
                          type='password'
                          autoComplete='false'
                          onChange={onInputChange}/>
            </Form.Field>
            <Message error>
              <Message.Content>
                <List bulleted>
                  {
                    _.keys(errors).map((key) => (
                      <List.Item key={key}>{errors[key]}</List.Item>
                    ))
                  }
                </List>
              </Message.Content>
            </Message>
            <Button.Group fluid widths={2}>
              <Button primary type='submit' className='login-submit' loading={submitting}>Login</Button>
              <Button.Or/>
              <Button onClick={() => navigate(`../create-account${queryString}`)}>
                Create Account
              </Button>
            </Button.Group>
            <div style={{marginTop: '15px'}}>
              <a href='' onClick={(e) => {
                e.preventDefault()
                navigate('../forgot-password')
              }}>Forgot Password</a>
            </div>
          </Form>
        </Segment>
      </Grid.Column>
    </Grid>
  )
}

let Login = (props) => {
  props = {...props, login}
  return (<_Login {...props}/>)
}

Login = withHelmet(Login, 'Login')
Login = withPropsPresent(Login, ['meLoaded'])
Login = withMeData(Login)
Login = withErrorHandling(Login)
Login = withQueryParams(Login)
Login = memo(Login)

export {Login, _Login, login}

export default Login